import { render, staticRenderFns } from "./stockup.vue?vue&type=template&id=478832ee&scoped=true&"
import script from "./stockup.vue?vue&type=script&lang=js&"
export * from "./stockup.vue?vue&type=script&lang=js&"
import style0 from "./stockup.vue?vue&type=style&index=0&id=478832ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478832ee",
  null
  
)

export default component.exports